import NepaliDate from 'nepali-date-converter';
export class DateRangeHelper {
  static dateFilters = [
    { dataTextField: 'Today', dataValueField: 'TODAY' },
    { dataTextField: 'Yesterday', dataValueField: 'YESTERDAY' },
    { dataTextField: 'Weakly', dataValueField: 'WEAKLY' },
    { dataTextField: 'Fort Nightaly', dataValueField: 'FORT_NIGHTALY' },
    { dataTextField: 'Current Month', dataValueField: 'CURRENT_MONTH' },
    { dataTextField: 'Last Month', dataValueField: 'LAST_MONTH' },
    { dataTextField: 'Quarterly', dataValueField: 'LAST_3_MONTHS' },
    { dataTextField: 'Half Yearly', dataValueField: 'HALF_YEARLY' },
    { dataTextField: 'Fiscal Year', dataValueField: 'FISCAL_YEAR' },
  ];

  static expiryDateFilters = [
    { dataTextField: 'Today', dataValueField: 'TODAY' },
    { dataTextField: 'Tomorrow', dataValueField: 'TOMORROW' },
    { dataTextField: 'Next 3 Days', dataValueField: 'NEXT3DAYS' },
    { dataTextField: 'Next 4 Days', dataValueField: 'NEXT4DAYS' },
    { dataTextField: 'Next 5 Days', dataValueField: 'NEXT5DAYS' },
    { dataTextField: 'Next 6 Days', dataValueField: 'NEXT6DAYS' },
    { dataTextField: 'Next 7 Days', dataValueField: 'NEXT7DAYS' },
    { dataTextField: 'Next 15 Days', dataValueField: 'NEXT15DAYS' },
    { dataTextField: 'Next 30 Days', dataValueField: 'NEXT30DAYS' },
    { dataTextField: 'Next 2 Months', dataValueField: 'NEXT2MONTHS' },
    { dataTextField: 'Next 3 Months', dataValueField: 'NEXT3MONTHS' },
    { dataTextField: 'Next 4 Months', dataValueField: 'NEXT4MONTHS' },
    { dataTextField: 'Next 5 Months', dataValueField: 'NEXT5MONTHS' },
    { dataTextField: 'Next 6 Months', dataValueField: 'NEXT6MONTHS' },
    { dataTextField: 'Next 1 Year', dataValueField: 'NEXT1YEAR' },
  ];
  public static getDateRange(filter: string): { fromDate: Date; toDate: Date } {
    const today = new Date();
    let fromDate: Date;
    let toDate: Date;

    // normalize time
    const startOfDay = (d: Date) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const endOfDay = (d: Date) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);

    switch (filter) {
      case 'TODAY':
        fromDate = startOfDay(today);
        toDate = endOfDay(today);
        break;

      case 'YESTERDAY':
        fromDate = startOfDay(new Date(today.setDate(today.getDate() - 1)));
        toDate = endOfDay(fromDate);
        break;

      case 'WEAKLY': // last 7 days
        toDate = endOfDay(new Date());
        fromDate = startOfDay(
          new Date(new Date().setDate(toDate.getDate() - 6)),
        );
        break;

      case 'FORT_NIGHTALY': // last 15 days
        toDate = endOfDay(new Date());
        fromDate = startOfDay(
          new Date(new Date().setDate(toDate.getDate() - 14)),
        );
        break;

      case 'CURRENT_MONTH':
        fromDate = startOfDay(
          new Date(today.getFullYear(), today.getMonth(), 1),
        );
        toDate = endOfDay(today);
        break;

      case 'LAST_MONTH':
        fromDate = startOfDay(
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
        );
        toDate = endOfDay(new Date(today.getFullYear(), today.getMonth(), 0));
        break;

      case 'LAST_3_MONTHS': // Quarterly
        fromDate = startOfDay(
          new Date(today.getFullYear(), today.getMonth() - 2, 1),
        );
        toDate = endOfDay(today);
        break;

      case 'HALF_YEARLY':
        fromDate = startOfDay(
          new Date(today.getFullYear(), today.getMonth() - 5, 1),
        );
        toDate = endOfDay(today);
        break;

      case 'FISCAL_YEAR': // India FY (Apr–Mar)
        // const year = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
        // fromDate = startOfDay(new Date(year, 3, 1));
        // toDate = endOfDay(new Date(year + 1, 2, 31));
        ///------28/01/2026
        fromDate = this.getNepalFiscalYearRange().fromDate;
        toDate = this.getNepalFiscalYearRange().toDate;
        break;

      default:
        fromDate = this.startOfDay(today);
        toDate = endOfDay(today);
    }

    return {
      fromDate: fromDate,
      toDate: toDate,
    };
  }

  public static getDateRangeNP(filter: string): {
    fromDate: Date;
    toDate: Date;
  } {
    debugger;
    const today = new Date();
    let fromDate: Date;
    let toDate: Date;

    // normalize time
    const startOfDay = (d: Date) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const endOfDay = (d: Date) =>
      new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);

    switch (filter) {
      case 'TODAY':
        fromDate = startOfDay(today);
        toDate = endOfDay(today);
        break;

      case 'YESTERDAY':
        fromDate = startOfDay(new Date(today.setDate(today.getDate() - 1)));
        toDate = endOfDay(fromDate);
        break;

      case 'WEAKLY': // last 7 days
        return this.getNepaliWeeklyRange();
        break;

      case 'FORT_NIGHTALY': // last 15 days
        return this.getNepaliFortNightlyRange();
        break;

      case 'CURRENT_MONTH':
        return this.getNepaliCurrentMonthRange();

      case 'LAST_MONTH':
        return this.getNepaliPreviousMonthRange();

      case 'LAST_3_MONTHS':
        return this.getNepaliLast3MonthsRange();

      case 'LAST_6_MONTHS':
        return this.getNepaliLast6MonthsRange();

      case 'FISCAL_YEAR': // India FY (Apr–Mar)
        // const year = today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
        // fromDate = startOfDay(new Date(year, 3, 1));
        // toDate = endOfDay(new Date(year + 1, 2, 31));
        fromDate = this.getNepalFiscalYearRange().fromDate;
        toDate = this.getNepalFiscalYearRange().toDate;
        break;

      default:
        fromDate = startOfDay(today);
        toDate = endOfDay(today);
    }

    return {
      fromDate: fromDate,
      toDate: toDate,
    };
  }

  public static getExpiryDateRange(filter: string): {
  fromDate: Date;
  toDate: Date;
} {
  const today = new Date();

  const startOfDay = (date: Date): Date =>
    new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

  const endOfDay = (date: Date): Date =>
    new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59,
      999
    );

  const addDays = (days: number): Date => {
    const date = new Date(today);
    date.setDate(date.getDate() + days);
    return date;
  };

  const addMonths = (months: number): Date => {
    const date = new Date(today);
    date.setMonth(date.getMonth() + months);
    return date;
  };

  let fromDate: Date;
  let toDate: Date;

  switch (filter) {

    case 'TODAY':
      fromDate = startOfDay(today);
      toDate = endOfDay(today);
      break;

    case 'TOMORROW':
      fromDate = startOfDay(addDays(1));
      toDate = endOfDay(addDays(1));
      break;

    case 'NEXT3DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(3));
      break;

    case 'NEXT4DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(4));
      break;

    case 'NEXT5DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(5));
      break;

    case 'NEXT6DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(6));
      break;

    case 'NEXT7DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(7));
      break;

    case 'NEXT15DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(15));
      break;

    case 'NEXT30DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(30));
      break;

    case 'NEXT2MONTHS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addMonths(2));
      break;

    case 'NEXT3MONTHS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addMonths(3));
      break;

    case 'NEXT4MONTHS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addMonths(4));
      break;

    case 'NEXT5MONTHS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addMonths(5));
      break;

    case 'NEXT6MONTHS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addMonths(6));
      break;

    case 'NEXT1YEAR':
      fromDate = startOfDay(today);
      toDate = endOfDay(addMonths(12));
      break;

    default:
      fromDate = startOfDay(today);
      toDate = endOfDay(today);
      break;
  }

  return {
    fromDate,
    toDate
  };
}

public static getExpiryDateRangeNP(filter: string): {
  fromDate: Date;
  toDate: Date;
} {
  const today = new Date();

  const startOfDay = (date: Date): Date =>
    new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

  const endOfDay = (date: Date): Date =>
    new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      59,
      999
    );

  const addDays = (days: number): Date => {
    const date = new Date(today);
    date.setDate(date.getDate() + days);
    return date;
  };

  let fromDate: Date;
  let toDate: Date;

  switch (filter) {

    case 'TODAY':
      fromDate = startOfDay(today);
      toDate = endOfDay(today);
      break;

    case 'TOMORROW':
      fromDate = startOfDay(addDays(1));
      toDate = endOfDay(addDays(1));
      break;

    case 'NEXT3DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(3));
      break;

    case 'NEXT4DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(4));
      break;

    case 'NEXT5DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(5));
      break;

    case 'NEXT6DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(6));
      break;

    case 'NEXT7DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(7));
      break;

    case 'NEXT15DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(15));
      break;

    case 'NEXT30DAYS':
      fromDate = startOfDay(today);
      toDate = endOfDay(addDays(30));
      break;

    // Nepali calendar month ranges
    case 'NEXT2MONTHS':
      return this.getNepaliNextMonthsRange(2);

    case 'NEXT3MONTHS':
      return this.getNepaliNextMonthsRange(3);

    case 'NEXT4MONTHS':
      return this.getNepaliNextMonthsRange(4);

    case 'NEXT5MONTHS':
      return this.getNepaliNextMonthsRange(5);

    case 'NEXT6MONTHS':
      return this.getNepaliNextMonthsRange(6);

    case 'NEXT1YEAR':
      return this.getNepaliNextMonthsRange(12);

    default:
      fromDate = startOfDay(today);
      toDate = endOfDay(today);
  }

  return {
    fromDate,
    toDate
  };
}
  private static formatDate(date: Date): string {
    return date.toISOString().split('T')[0]; // YYYY-MM-DD
  }
  private static getNepalFiscalYearRange() {
    const todayBS = new NepaliDate();
    // const fyStartBS = new NepaliDate(todayBS.getYear(), 4, 1); // Shrawan 1
    // const fyEndBS = new NepaliDate(todayBS.getYear() + 1, 3, 31); // Ashad end

    const fyStartBS = new NepaliDate(todayBS.getYear(), 3, 1); // Shrawan 1
    const fyEndBS = new NepaliDate(todayBS.getYear() + 1, 2, 31); // Ashad end

    const fromDate = fyStartBS.toJsDate();
    const toDate = fyEndBS.toJsDate();

    return {
      fromDate: fromDate,
      toDate: toDate,
    };
  }

  // BS DATE RANGE START
  private static startOfDay(d: Date) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate());
  }

  private static endOfDay(d: Date) {
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);
  }

  private static getNepaliWeeklyRange(): { fromDate: Date; toDate: Date } {
    const todayBS = new NepaliDate();

    // subtract 6 Nepali days (today included)
    const fromBS = new NepaliDate(
      todayBS.getYear(),
      todayBS.getMonth(),
      todayBS.getDate() - 6,
    );

    return {
      fromDate: this.startOfDay(fromBS.toJsDate()),
      toDate: this.endOfDay(todayBS.toJsDate()),
    };
  }

  private static getNepaliFortNightlyRange(): { fromDate: Date; toDate: Date } {
    const todayBS = new NepaliDate();

    // subtract 14 Nepali days (today included)
    const fromBS = new NepaliDate(
      todayBS.getYear(),
      todayBS.getMonth(),
      todayBS.getDate() - 14,
    );

    return {
      fromDate: this.startOfDay(fromBS.toJsDate()),
      toDate: this.endOfDay(todayBS.toJsDate()),
    };
  }
public static getNepaliNextMonthsRange(months: number): {
  fromDate: Date;
  toDate: Date;
} {
  const today = new Date();

  // AD -> Nepali
  const nepaliToday = new NepaliDate(today);

  const bsYear = nepaliToday.getYear();
  const bsMonth = nepaliToday.getMonth();
  const bsDay = nepaliToday.getDate();

  // Calculate target BS month
  let targetMonth = bsMonth + months;
  let targetYear = bsYear;

  while (targetMonth > 12) {
    targetMonth -= 12;
    targetYear++;
  }

  const lastDay = this.getNepaliMonthLastDay(
    targetYear,
    targetMonth
  );

  // Preserve today's day where possible.
  // Example: BS month has 31 days but target month has 29.
  const targetDay = Math.min(bsDay, lastDay);

  const fromDate = new NepaliDate(
    bsYear,
    bsMonth,
    bsDay
  );

  const toDate = new NepaliDate(
    targetYear,
    targetMonth,
    targetDay
  );

  
return {
      fromDate: this.startOfDay(fromDate.toJsDate()),
      toDate: this.endOfDay(toDate.toJsDate()),
    };

  
}
  private static getNepaliMonthLastDay(year: number, month: number): number {
    return new NepaliDate(year, month + 1, 0).getDate();
  }
  private static getNepaliCurrentMonthRange() {
    const todayBS = new NepaliDate();

    const year = todayBS.getYear();
    const month = todayBS.getMonth();

    const fromBS = new NepaliDate(year, month, 1);
    const lastDay = this.getNepaliMonthLastDay(year, month);
    const toBS = new NepaliDate(year, month, lastDay);

    return {
      fromDate: this.startOfDay(fromBS.toJsDate()),
      toDate: this.endOfDay(toBS.toJsDate()),
    };
  }

  private static getNepaliPreviousMonthRange() {
    const todayBS = new NepaliDate();

    let year = todayBS.getYear();
    let month = todayBS.getMonth() - 1;

    if (month < 0) {
      month = 11;
      year--;
    }

    const fromBS = new NepaliDate(year, month, 1);
    const lastDay = this.getNepaliMonthLastDay(year, month);
    const toBS = new NepaliDate(year, month, lastDay);

    return {
      fromDate: this.startOfDay(fromBS.toJsDate()),
      toDate: this.endOfDay(toBS.toJsDate()),
    };
  }

  private static getNepaliLast3MonthsRange() {
    const todayBS = new NepaliDate();

    let year = todayBS.getYear();
    let month = todayBS.getMonth() - 2;

    if (month < 0) {
      month += 12;
      year--;
    }

    const fromBS = new NepaliDate(year, month, 1);

    return {
      fromDate: this.startOfDay(fromBS.toJsDate()),
      toDate: this.endOfDay(new Date()),
    };
  }

  private static getNepaliLast6MonthsRange(): { fromDate: Date; toDate: Date } {
    const todayBS = new NepaliDate();

    let year = todayBS.getYear();
    let month = todayBS.getMonth() - 5; // go back 5 months

    if (month < 0) {
      month += 12;
      year--;
    }

    // Start: 1st day of the month (6 months window)
    const fromBS = new NepaliDate(year, month, 1);

    // End: today (AD)
    const toDate = this.endOfDay(new Date());

    return {
      fromDate: this.startOfDay(fromBS.toJsDate()),
      toDate: toDate,
    };
  }

  //BS DATE RANGE END
}
